    <!-- LARGE MODAL -->
    <div class="max-w-md w-full mx-auto">
        <!-- Modal Header -->
        <div class="flex justify-between items-center p-4 border-b border-gray-200">
            <h6 class="text-lg font-semibold text-gray-800">Un-Reserve Booking</h6>
            <button 
                type="button" 
                class="text-gray-400 hover:text-gray-500 focus:outline-none"
                (click)="close()"
            >
                <span class="sr-only">Close</span>
                <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
        
        <!-- Modal Body -->
        <div class="p-6">
            <div class="text-center">
                <span class="text-yellow-600 font-medium">
                    Are you sure you want to un-reserve this booking?<br/>
                    <b class="font-semibold">Your confirmation numbers will also be removed</b>
                </span>
            </div>
        </div>
        
        <!-- Modal Footer -->
        <div class="flex justify-between items-center p-4 border-t border-gray-200">
            <button 
                type="button" 
                class="px-4 py-2 text-blue-600 hover:text-blue-800 font-medium focus:outline-none"
                (click)="itinUnPreBook(data.quote, true)"
            >
                Yes
            </button>
            <button 
                type="button" 
                class="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded focus:outline-none focus:ring-2 focus:ring-gray-500"
                (click)="close()"
            >
                No
            </button>
        </div>
    </div>